import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {Field} from "../form/Field";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {IWindow} from "../../index";
// import {BarChart} from "../charts/BarChart";
// import {DoughnutChat} from "../charts/DoughnutChat";
import {HasPermission} from "../HasPermission";

const IWindow: IWindow = (window as IWindow);

export class DashboardPollingFormData {
    @observable election_id = null; 
    @observable position_id = null;
    @observable party_id = IWindow.initialState.user.party_id;
}

export class DashboardPollingForm extends CrudForm {
    modelName = 'Dashboard';
    showSubmitButton = false;
    @observable party_candidates: [];
    @observable candidate_by_position: any = [];
	@observable totalVotes: any = [];
    @observable other_party_candidates: any = [];
	@observable is_admin = IWindow.initialState.user.user_type;
    @observable electionSubscription = {
        registeredVoters : 0,
		registeredVotersPollingUnit : 0,
		registeredVotersTotal: 0,
		PVCregisteredVotersTotal: 0,
        accreditedVoters : 0,
        accreditedVotersData : 0,
        rejectedVoters   : 0,
        rejectedVotersData   : 0,
        disputedVoters   : 0,
        disputedVotersData   : 0,
        election_polling_unit : 0,
        election_polling_unit_subscriptions : 0,
        election_unsubscribed_polling_unit : 0,
        federal_constituencies: 0,
        local_government_areas: 0,
        senatorial_districts: 0,
        state_constituencies: 0,
        states: 0,
        wards: 0,
        incidence_count: 0,
        election_candidates_votes: [],
        pollingUnitName: [],
        pollingUnitCode: [],
        pollingUnitState: [],
        total_votes: 0, // [],
        grandTotal: 0,
        election_positions: [],
        check_list_count: [],
		candidateName: [],
		partyName: [],
		
       
    };
    @observable check_lists: any = [];

    loadMoreData(props: any, module: any) {
        this.onLoadCheckLists();
    }

    onLoadCheckLists = () => {
        api.partyCheckList.getListActionReport({ 
            filters: {
                type: 'polling_unit',
                is_excluded: 0,
                election_id:  this.formStore.getValue('election_id')
            }
        }).then((data: any) => {
            this.check_lists = data;
        });
    };

    onChangeElection = () => { 
        this.formStore.getValue('election_id') &&
          api.dashboard.getElectionPollingUnitSubscriptionAction({
            election_id: this.formStore.getValue('election_id'),
			party_id:  this.formStore.getValue('party_id'),
        }).then((data: any) => {
             this.electionSubscription = data;
			 
			 console.log('election subscription - ' + this.electionSubscription);
			 console.log('total votes - ' + this.electionSubscription.total_votes);
			 console.log('polling data - ' + this.electionSubscription.pollingUnitName);
			 
			 
			 
             this.party_candidates = data.election_candidates_votes; /* .filter((candidate: any) => {
                return candidate.party_id == (IWindow.initialState.user.party_id ? IWindow.initialState.user.party_id : this.formStore.getValue('party_id') );
             }); */
			

            this.other_party_candidates = data.election_candidates_votes.filter((candidate: any) => {
                return candidate.party_id !== (IWindow.initialState.user.party_id ? IWindow.initialState.user.party_id : this.formStore.getValue('party_id') );
            });

            if (data.election_positions && data.election_positions.length) {
                this.formStore.setValue('position_id', data.election_positions[0].value);
                this.candidate_by_position = data.election_candidates_votes.filter((candidate: any) => {
                  
                    return candidate.position_id === data.election_positions[0].value;
                }).map((candidate: any) => {
                    return {
                        label: candidate.name,
                        value: candidate.votes
                    };
                });
            }
        });
    };

    getCandidateRow = (candidate: any,totalvotes: any) => {
        return <tr key={'candidate-row' + candidate.id}>
			
			<td>
                <div className=""> 
				{ 
					candidate.party_logo && candidate.party_logo.url ?
				<img src={candidate.party_logo.url} style={{width: 50, height: 50}}/> :
                                    <img src="https://fakeimg.pl/50x50/"/>                
									}
									</div>
                
            </td>
			
            <td>
                <div className="">
                    {candidate.party_name}
                </div>
            </td>
			<td>
				<div className="">{candidate.name}
                </div>
			</td>
            <td className="text-center">
                <div className="icon-candidates text-success my-1"></div>
                <div className="comp-position">
                    <div className="text-center">
                        <small>{candidate.position_name}</small>
                    </div>
                    <div className="text-center">
                        <small>{candidate.region_name}</small>
                    </div>
                </div>
            </td>
            { /* <td><span className="spnvot" >
			<span className="spnvot spncolor" style={{width: Math.ceil( (candidate.votes / totalvotes) * 100) ? Math.ceil( (candidate.votes / totalvotes) * 100) : 0 + 'px'}}></span>
			</span></td>
			<td className="text-center "  >{ Math.ceil( (candidate.votes / totalvotes) * 100) ? Math.ceil( (candidate.votes / totalvotes) * 100) : 0 } %</td> */ }
			<td><span className="spnvot" >
			<span className="spnvot spncolor" style={{width: Math.ceil( (candidate.votes / this.electionSubscription.grandTotal) * 100) ? Math.ceil( (candidate.votes / this.electionSubscription.grandTotal) * 100) : 0 + 'px'}}></span>
			</span></td>
			<td className="text-center "  >{ Math.ceil( (candidate.votes / this.electionSubscription.grandTotal) * 100) ? Math.ceil( (candidate.votes / this.electionSubscription.grandTotal) * 100) : 0 } %</td>
			
			<td className="text-center">
                <div className="comp-votes">
                    <span>{candidate.votes}</span>
                </div>
            </td>
			
			
        </tr>
    };

    onChangePosition = (position: any) => {
        this.candidate_by_position = this.electionSubscription.election_candidates_votes.filter((candidate: any) => {
            return candidate.position_id === position;
        }).map((candidate: any) => {
            return {
                label: candidate.name,
                value: candidate.votes
            };
        });
    };

    onLoadElections = () => {
        return api.election.getListAction({
            filters: {
                party_id: this.formStore.getValue('party_id'),
            }
        }).then((data: any) => {
            if (data && data.length) {
                this.formStore.setValue('election_id', data[0].id);
                this.onChangeElection();
            }
            return data;
        });
    };
	
	goToElectionSubmitResult() {
        window.location.href = '/election-results';
    };

    renderFields() {
        return (

            <>
			 
			
                <div className="row">
                    <div className="ml-auto col-md-3" >
                        <Field
                            key="dashboard-election"
                            name="election_id"
                            placeholder="Select Election..."
                            component={Select}
                            loadOptions={this.onLoadElections}
                            store={this.formStore}
                            required={true}
                            onChange={this.onChangeElection}
                        />
						
						{ this.is_admin == "superuser" ?
					 
						 <Field
                            key={'form_party_id_' + this.formStore.getValue('election_id')}
                            name="party_id"
                            placeholder="Select Party..."
                            component={Select}
                            // loadOptions={this.onLoadElections}
							loadOptions={() => {
                            return api.party.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id') /* ,
                                    include_competitor_party: 0 */
                                }
                            }).then((data: any) => {
								if (data && data.length) {
									this.formStore.setValue('party_id', data[0].id);
									this.onChangeElection();
								}
							
                                return data.data;
                            });
                        }}
                            store={this.formStore}
                            required={true}
                            onChange={this.onChangeElection}
                        />
						: ''
						}
                    </div>
					 
                </div>
				
				<div className="row">
				
				
					<div className="col-xl-6 d-flex flex-column"
							 key={'subscription-polling-unit' + this.formStore.getValue('election_id')}>
							 
							<div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
								<div className="card-header d-flex align-items-center">
									<span className="icon-structure mr-2"></span>
									<h6>MY POLLING UNIT</h6>
								</div>
								<div className="card-body py-0 d-flex flex-column">
									
									
									<div className="row no-gutters flex-grow-1">
										<div className="col-sm-4   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											<div className="">
												<div className="stat-label">Polling Unit Name: </div>
											</div>
										</div>
										
										<div className="col-sm-6   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											<div className="">
												<div className="stat-label"><strong>{this.electionSubscription.pollingUnitName}</strong> </div>
											</div>
										</div>
										
									</div>	
									
									<div className="row no-gutters flex-grow-1">
										<div className="col-sm-4   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											<div className="">
												<div className="stat-label">Polling Unit Code: </div>
											</div>
										</div>
										
										<div className="col-sm-6   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											<div className="">
												<div className="stat-label"><strong>{this.electionSubscription.pollingUnitCode}</strong> </div>
											</div>
										</div>
										
									</div>


									<div className="row no-gutters flex-grow-1">
										<div className="col-sm-4   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											<div className="">
												<div className="stat-label">Polling Unit State: </div>
											</div>
										</div>
										
										<div className="col-sm-6   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											<div className="">
												<div className="stat-label"><strong>{this.electionSubscription.pollingUnitState}</strong> </div>
											</div>
										</div>
										
									</div>	



									<div className="row no-gutters flex-grow-1">
										
<HasPermission module='election_polling_unit_result' permission="add">										
										<div className="col-sm-12   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											 <button onClick={() => this.goToElectionSubmitResult()} className="btn btn-dark buttoncol" > SUBMIT RESULT  </button>
											 
										</div>
</HasPermission>										
										
									</div>			

									
									
									
									
								</div>
							</div>
							
						
							
					</div>



					<div className="col-xl-6 d-flex flex-column"
							 key={'subscription-polling-unit-cand' + this.formStore.getValue('election_id')}>
							<div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
								<div className="card-header d-flex align-items-center">
									<span className="icon-candidates mr-2"></span>
									<h6>MY CANDIDATE</h6>
								</div>
								
								<div className="card-body py-0 d-flex flex-column">
									
									
									<div className="row no-gutters flex-grow-1">
										<div className="col-sm-4   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											<div className="">
												<div className="stat-label">Name: </div>
											</div>
										</div>
										
										<div className="col-sm-6   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											<div className="">
												<div className="stat-label"><strong>{this.electionSubscription.candidateName}</strong> </div>
											</div>
										</div>
										
									</div>	
									
									
									<div className="row no-gutters flex-grow-1">
										<div className="col-sm-4   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											<div className="">
												<div className="stat-label">Party: </div>
											</div>
										</div>
										
										<div className="col-sm-6   py-2 d-sm-flex flex-sm-column justify-content-sm-center">
											<div className="">
												<div className="stat-label"><strong>{this.electionSubscription.partyName}</strong> </div>
											</div>
										</div>
										
									</div>	
									
									
								</div>	
								
								
								
								
								
								
							</div>
					</div>		




					
				</div>
				
				
{ /*
                <div className="row">
				
								
				
				

                    <div className="col-xl-6 d-flex flex-column"
                         key={'subscription-polling-unit' + this.formStore.getValue('election_id')}>
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-nigerian-naira mr-2"></span>
                                <h6>Election Subscription</h6>
                            </div>
                            <div className="card-body py-0 d-flex flex-column">
                                <div className="row no-gutters flex-grow-1">
                                    <div
                                        className="col-sm-4 dash-sep-sm-right py-4 d-sm-flex flex-sm-column justify-content-sm-center">
                                        <div className="text-center">
                                            <div className="stat-label">Polling units<br/>subscribed</div>
                                            <div
                                                className="stat-value">{this.electionSubscription.election_polling_unit_subscriptions}</div>
                                        </div>
                                        <div className="text-center mt-4">
                                            <div className="stat-label">Polling units<br/>not subscribed</div>
                                            <div
                                                className="stat-value">{this.electionSubscription.election_unsubscribed_polling_unit}</div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 ">
                                        {
                                            this.formStore.getValue('election_id') ?
                                                <DoughnutChat
                                                    id="polling-unit-chart"
                                                    key={'polling-unit-subcripbtion-chart'}
                                                    title="Polling Units"
                                                    backgroundColor={[
                                                        'rgb(197,44,3)',
                                                        'rgb(41,138,61)',
                                                    ]}
                                                    backgroundHoverColor={[
                                                        'rgba(197,44,3, 0.8)',
                                                        'rgba(41,138,61, 0.78)',
                                                    ]}
                                                    legend={{
                                                        display: true
                                                    }}
                                                    data={[
                                                        {
                                                            label: 'Unsubscribed',
                                                            value: this.electionSubscription.election_unsubscribed_polling_unit,
                                                        },
                                                        {
                                                            label: 'Subscribed',
                                                            value: this.electionSubscription.election_polling_unit_subscriptions,
                                                        }
                                                    ]}
                                                /> : ''
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
						 
                    </div>
					
					
 
                    <div className="col-xl-6 mt-4 mt-xl-0 d-flex flex-column"
                         key={'subscription-candidates' + this.formStore.getValue('election_id')}>
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-candidates mr-2"></span>
                                <h6>Candidates </h6>
                                { 
                                    this.formStore.getValue('election_id') &&
                                    this.electionSubscription.election_positions &&
                                    this.electionSubscription.election_positions.length ?
                                        <div className="ml-auto col-md-5">
                                            <Field
                                                key="dashboard-position"
                                                name="position_id"
                                                placeholder="Select Postions..."
                                                component={Select}
                                                store={this.formStore}
                                                options={this.electionSubscription.election_positions}
                                                required={true}
                                                onChange={this.onChangePosition}
                                            />
                                        </div>
                                        : ''
                                }
                            </div>
                            <div className="card-body">
                                {
                                    this.formStore.getValue('position_id') &&
                                    this.candidate_by_position &&
                                    this.candidate_by_position.length ?
                                        <BarChart
                                            id="candidates-chart"
                                            key={'candidate-bar-chart'}
                                            title="Candidates Chart"
                                            data={this.candidate_by_position}/>
                                        : ''
                                }

                            </div>
                        </div>
                    </div>
					 
					
					

                </div>
				
 
                <div className="row py-2" key={'subscription-region' + this.formStore.getValue('election_id')}>
                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">States</div>
                            <div className="stat-value">{this.electionSubscription.states}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Senatorial Districts</div>
                            <div className="stat-value">{this.electionSubscription.senatorial_districts}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Local Government Areas</div>
                            <div className="stat-value">{this.electionSubscription.local_government_areas}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Wards</div>
                            <div className="stat-value">{this.electionSubscription.wards}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Polling Units</div>
                            <div
                                className="stat-value">{this.electionSubscription.election_polling_unit_subscriptions}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Federal Constituencies</div>
                            <div className="stat-value">{this.electionSubscription.federal_constituencies}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">State Constituencies</div>
                            <div className="stat-value">{this.electionSubscription.state_constituencies}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Incidences</div>
                            <div className="stat-value text-danger">
                                {this.electionSubscription.incidence_count && this.formStore.getValue('election_id') ?
                                    <a href={"/party/" + this.formStore.getValue('election_id') + '/incidence'}
                                       className="text-danger" target="_blank">
                                        {this.electionSubscription.incidence_count} </a>
                                    : this.electionSubscription.incidence_count}
                            </div>
                        </div>
                    </div>

                </div>
*/ }
                <div className="mt-3">

                    <div className="d-flex flex-column">
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            
                            <div className="card-body py-0 d-flex flex-column">
                                


							<div className="card-header d-flex align-items-center">
                                <span className="icon-bar-chart mr-2"></span>
                                <h6>MY POLLING UNIT ELECTION RESULTS</h6>
                            </div>
							
							
								<div className="row pt-2">
									
									<div className="col-sm-6 col-xl-3 d-flex flex-column mt-2" key={'inecVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">INEC REGISTERED<br/> VOTERS</div>
											<div className="stat-valuecnt">{this.electionSubscription.registeredVotersTotal}</div>
										</div>
									</div>
									
									<div className="col-sm-6 col-xl-3 d-flex flex-column mt-2" key={'inecVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">PVC<br/> COLLECTED</div>
											<div className="stat-valuecnt">{this.electionSubscription.PVCregisteredVotersTotal}</div>
										</div>
									</div>
									
									<div className="col-sm-6 col-xl-3 d-flex flex-column mt-2" key={'registeredVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">REGISTERED VOTERS AT POLLING UNIT</div>
											<div className="stat-valuecnt">{this.electionSubscription.registeredVotersPollingUnit}</div>
										</div>
									</div>
									
									  
									 <div className="col-sm-6 col-xl-3 d-flex flex-column mt-2" key={'accreditedVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">POLLING UNIT ACCREDICTED VOTERS</div>
											<div className="stat-valuecnt">{this.electionSubscription.accreditedVotersData}</div>
										</div>
									</div> 
									
									
										<div className="col-sm-6 col-xl-4 d-flex flex-column mt-2" key={'rejectedVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">TOTAL VOTES</div>
											<div className="stat-valuecnt">{Number(this.electionSubscription.grandTotal)}</div>
										</div>
									</div> 
										
									<div className="col-sm-6 col-xl-4 d-flex flex-column mt-2" key={'disputedVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">TOTAL VALID VOTES</div>
											<div className="stat-valuecnt">{(Number(this.electionSubscription.grandTotal) - (Number(this.electionSubscription.rejectedVotersData) + Number(this.electionSubscription.disputedVotersData) ))}</div>
										</div>
									</div> 
									
									<div className="col-sm-6 col-xl-4 d-flex flex-column mt-2" key={'disputedVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">TOTAL INVALID VOTES</div>
											<div className="stat-valuecnt">{(Number(this.electionSubscription.rejectedVotersData) + Number(this.electionSubscription.disputedVotersData) )}</div>
										</div>
									</div> 
									
										
								
								</div>
								


								<div className="row pt-2">&nbsp;</div>
								<div className="row pt-2">&nbsp;</div>

                                <div className="row pt-2">
                             
                               
							   
                                    <div className="col-xl-12 dash-sep-xl-right">
                                        
                                        <div className="competitor-list table-responsive"
                                             key={"my-party" + this.formStore.getValue('election_id')}>
                                            <table className="table table-hover border-top bgcolornw">
												<thead>
													<th>Logo</th>
													<th>Party</th>
													<th>Candidate Name</th>
													<th className="text-center">Postions</th>
													<th></th>
													<th className="text-center">%</th>
													<th className="text-center">Votes</th>
												</thead>
                                                <tbody>
												{
													
												
                                                    this.formStore.getValue('election_id') && this.party_candidates &&
                                                    this.party_candidates.length ?
                                                        this.party_candidates.map((candidate: any) => {
                                                            return (
                                                                this.getCandidateRow(candidate,this.electionSubscription.total_votes)
                                                            );
                                                        }, this)
                                                        : <tr>
                                                            <td colSpan={7}>
                                                                <div className="comp-candidate">No Candidates</div>
                                                            </td>
                                                        </tr>
                                                }
												
														<tr>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															
															
															<td colSpan={3} className="text-right" >Total Valid Votes:</td>
															<td className="text-center fotvalue">{this.electionSubscription.total_votes}</td>
														</tr>	
														
														<tr>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															
															
															<td  colSpan={3}  className="text-right">Disputed Votes:</td>
															<td className="text-center fotvalue coldispute">{this.electionSubscription.disputedVotersData}</td>
														</tr>

														<tr>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
																														
															
															<td  colSpan={3} className="text-right">Rejected Votes:</td>
															<td className="text-center fotvalue colrej">{this.electionSubscription.rejectedVotersData}</td>
														</tr>	

														<tr className="bggrand">
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
																																													
															<td  colSpan={3} className="text-right">Grand Total:</td>
															<td className="text-center fotvalue">{(this.electionSubscription.grandTotal)}</td>
														</tr>															

                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
									
									
                                 
                 
                              


                                    




                                    


                               
                </div>


                <div className="row pt-2">&nbsp;</div>







                            </div>
                        </div>
                    </div>

                </div>

                






               









            </>
        );
    }
}

export class DashboardPollingPage extends React.Component {
    modelName = 'Dashboard';

    render() {
        return (
            <>
                <DashboardPollingForm
                />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/DashboardPollingPage.tsx